/**
 * Thresholds for displaying toolbox buttons.
 */
export const BUTTONS_THRESHOLDS = [
    {
        width: 880,
        order: [
            'desktop',
            'audioOnly',
            'chat',
            'microphone',
            'camera',
            'tileview',
            'invite',
            'security',
            'participants',
            'virtualBackgroundCircle',
        ],
    },
    {
        width: 720,
        order: [
            'desktop',
            'audioOnly',
            'chat',
            'microphone',
            'camera',
            'invite',
            'tileview',
            'participants',
            'cameraFlip',
            'virtualBackgroundCircle',
        ],
    },
    {
        width: 565,
        order: [
            'desktop',
            'audioOnly',
            'chat',
            'microphone',
            'camera',
            'tileview',
            'participants',
            'cameraFlip',
        ],
    },
    {
        width: 200,
        order: ['chat', 'microphone', 'camera', 'cameraFlip', 'tileview'],
    },
    // {
    //   width: 200,
    //   order: ['microphone', 'camera'],
    // },
];
